/* eslint-disable no-undef */
import React from 'react';
import { Flex, Heading, Text, Image, Button } from 'rebass';
import closeIcon from 'assets/icons/close.png';
import styled from 'styled-components';
import { Send } from 'styled-icons/feather/Send';
import ErrorMessage from 'components/ErrorMessage';
import Form from 'components/Form';
import Field from 'components/Field';
import { format } from 'date-fns';
import { startSendMessage, resolveSendMessage } from './actions';
import ModalContent from '../ModalContent';
import useSendMessages from './hooks/useSendMessages';

const FormButton = styled(Button)<any>`
  cursor: ${props => (props.submitting ? 'wait' : 'pointer')};
  outline: none;
  padding: 0px;
  margin-left: 10px;
`;

const Content = styled(ModalContent)`
  flex-direction: column;
  padding: 35px;
`;

const MessagesWrapper = styled(Flex)`
  height: 25vh;
  overflow-x: auto;
  padding-right: 20px;
`;

interface SendMessagesProps {
  closeModalHandler: VoidFunction;
}

const SendMessages: React.FC<SendMessagesProps> = ({ closeModalHandler }) => {
  const { candidateId, loading, messages } = useSendMessages();

  return (
    <Content>
      <Flex width="100%" justifyContent="flex-end" mb={1} onClick={closeModalHandler}>
        <Image src={closeIcon} css="cursor: pointer" />
      </Flex>
      <Heading fontSize="26px" textAlign="center" mb={3}>
        Contact
      </Heading>
      {!loading && (
        <MessagesWrapper width="100%" flexDirection="column" mb={3}>
          {messages.map((message: any) => (
            <Flex width="100%" key={message.id} flexDirection="column" mb={2}>
              <Flex width="100%" justifyContent="space-between">
                <Heading fontSize="16px" mr={2} mb={1}>
                  {message.sender.firstName} {message.sender.lastName}
                </Heading>
                <Text>{format(new Date(message.createdAt), 'MM.DD.YYYY h:mma')}</Text>
              </Flex>
              <Text as="p" width="400px" css="word-wrap: break-word;">
                {message.text}
              </Text>
            </Flex>
          ))}
        </MessagesWrapper>
      )}
      <Form
        startSubmitAction={startSendMessage().type}
        resolveSubmitAction={resolveSendMessage().type}
        setPayload={(action: object, payload: any) => ({
          ...action,
          payload: {
            ...payload,
            candidateId,
          },
        })}
      >
        {(formProps: any) => {
          const { submitting, submitErrors, form } = formProps;
          return (
            <Flex alignItems="center">
              {submitErrors && <ErrorMessage>{submitErrors.data.error.message}</ErrorMessage>}
              <Field
                name="note"
                inputType="textarea"
                placeholder="type your note"
                required
                mb="0"
                maxLength="250"
                height="42px"
                afterSubmit={() => form.reset()}
              />
              <Flex css="cursor: pointer">
                <FormButton type="submit" bg="transparent" submitting={submitting}>
                  <Send size="28" color="black" />
                </FormButton>
              </Flex>
            </Flex>
          );
        }}
      </Form>
    </Content>
  );
};

export default SendMessages;
